export default "/images/vendor/flag-icon-css/flags/4x3/ly.svg?0ea8dfcec5cc820043a4a07c40a56fdc";